import React, { useState } from 'react'
import { Button, Checkbox, Dropdown, Menu } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFontCase } from '@fortawesome/pro-solid-svg-icons/faFontCase'
import { faValueAbsolute } from '@fortawesome/pro-solid-svg-icons/faValueAbsolute'
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'
import { faColumns } from '@fortawesome/pro-solid-svg-icons/faColumns'
import { faSortNumericDownAlt } from '@fortawesome/pro-solid-svg-icons/faSortNumericDownAlt'
import { faThList } from '@fortawesome/pro-solid-svg-icons/faThList'
import { FilterOptionsTypesEnum } from 'enum/filterType.enum'
import { ITableHeaders } from 'interfaces/tableProps'
import styles from './ShowColumns.module.scss'

interface IShowColumns {
  columns: ITableHeaders[]
  onChange: any
  translations: any
  customColumnVisibilityNode?: React.ReactNode
}

const ShowColumns: React.FC<IShowColumns> = ({ columns, onChange, translations, customColumnVisibilityNode }) => {
  const [show, setShow] = useState(false)

  const handleChange = (index: number) => {
    const aux = columns.map((column: ITableHeaders) => ({ ...column }))
    aux[index].visible = aux[index].visible === 'visible' ? 'hidden' : 'visible'
    onChange(aux)
  }

  const getIcon = (type: any) => {
    const { list, tagsList, string, number, date, boolean } = FilterOptionsTypesEnum
    switch (type) {
      case list:
        return faThList
      case tagsList:
        return faThList
      case string:
        return faFontCase
      case number:
        return faSortNumericDownAlt
      case date:
        return faCalendarAlt
      case boolean:
        return faValueAbsolute
      default:
        return faFontCase
        break
    }
  }

  return (
    <Dropdown
      className={`rankmiTable-showColumns-container ml-2 ${styles.showColumnsContainer} m-0`}
      overlay={
        <Menu>
          <Menu.Item disabled className={styles.header} key="header">
            {translations.header.tableProperties}
          </Menu.Item>
          {columns.map(({ value, title, visible, type, hideable }, index: number) => (
            <Menu.Item disabled={visible === true} key={`rankmiTable-showColumns-${index}-${Math.random()}`} style={{ display: hideable ? 'block' : 'none' }}>
              <Checkbox checked={visible === 'visible' || visible === true} onChange={() => visible !== true && handleChange(index)}>
                <FontAwesomeIcon icon={getIcon(type)} /> {value || title}
              </Checkbox>
            </Menu.Item>
          ))}
          {customColumnVisibilityNode && (
            <Menu.Item disabled className={styles.header} key="customColumnVisibilityNode">
              {customColumnVisibilityNode}
            </Menu.Item>
          )}
        </Menu>
      }
      overlayClassName="rankmiTable-showColumns"
      placement="bottomRight"
      visible={show}
      onVisibleChange={() => setShow(!show)}
    >
      <Button size="small">
        <FontAwesomeIcon icon={faColumns} />
      </Button>
    </Dropdown>
  )
}

export default ShowColumns
